"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _Button = require("./Button.style");

var sizeStyles = function sizeStyles(props) {
  if (props.size === 'medium') {
    return (
      /*#__PURE__*/
      (0, _reactEmotion.css)("min-width:90px;height:32px;padding:0px 24px 0 18px;")
    );
  }

  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("min-width:120px;height:40px;padding:0px 24px;")
  );
};
/* const statusColors = {
  normal: 'white',
  hover: 'accentHover',
  filled: 'accentClicked',
}; */


var typeStyles = function typeStyles(_ref) {
  var color = _ref.theme.color,
      type = _ref.type,
      borderType = _ref.borderType,
      disabled = _ref.disabled;

  // const statusColor = statusColors[status];
  if (type === 'filled') {
    return (
      /*#__PURE__*/
      (0, _reactEmotion.css)("background-color:white;color:", color.accent, ";fill:", color.accent, ";", disabled || "\n        &:hover {\n          background-color: ".concat(color.accentHover, ";\n          color: white;\n          fill: white;\n        }\n      "), "\n      \n      &:active{background-color:", color.accentClicked, ";color:white;fill:white;}")
    );
  } // type = 'bordered'
  // color: ${color.accentHover};
  // fill: ${color.accentHover};
  // box-shadow: 0 0 0 2px ${color.accentHover};
  // border-color: transparent;
  // color: ${ color.accentClicked };
  // fill: ${ color.accentClicked };
  // border - color: ${ color[statusColor + 'Clicked'] || color.accent };


  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", color.white, ";fill:", color.white, ";border-radius:4px;border:", borderType, " 1px ", color.white, ";", disabled || "\n      &:hover {\n        color: white;\n        fill: white;\n        background-color: ".concat(color.accentHover, ";\n        border-color: ").concat(color.accentHover, ";\n      }\n      \n      &:active {\n        color: ").concat(color.white, ";\n        fill: ").concat(color.white, ";\n        border-color: ").concat(color.accentClicked, ";\n        background-color: ").concat(color.accentClicked, ";\n        border-style: solid;\n        box-shadow: none;\n      }\n    "))
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("button", {
  target: "css-qp51f70"
})(_Button.buttonStyles, "\n    ", sizeStyles, "\n    ", typeStyles, "\n    border-radius:4px;letter-spacing:0.3px;font-weight:600;"));

exports.default = _default;